



















import { defineComponent, getCurrentInstance, Ref } from '@vue/composition-api'
import { ApolloError, NetworkStatus } from 'apollo-client'

import SettingImportModal from '@/components/templates/h/SettingImportModal.vue'
import PageView from '@/components/templates/h/yosan-haibun/item-order-num-adj/PageView.vue'
import {
  ItemOrderNumAdjExtractCondition,
  ItemOrderNumAdjOutputCondition,
  ColumnLabel,
} from '@/types/entities'
// import { TemplateFile, ResourceType } from '@/types/generated/graphql'
import {
  TemplateFile,
  ResourceType,
  Where,
  WhereOp,
  OrderBy,
  OrderByDirection,
  OrderByNullsOption,
  VUiPItemOrderNumAdjsCountDocument,
} from '@/types/generated/graphql'
import {
  OUTPUT_COND_DELETE,
  OUTPUT_COND_ITEM,
  OUTPUT_COND_STORE,
  OUTPUT_EXTRACT_TARGET_DEFAULT,
  SELECT_MAX_COUNT,
} from '@/utils/constant'
import { EXPORT_FILENAME } from '@/utils/constant'
import importExportHelper from '@/utils/importExportHelper'
import { addDayYMD } from '@/utils/mixin'
import { setWhereValue, setWhereValues } from '@/utils/searchConditionDef'
import Toast from '@/utils/toast'
const DEFAULT_OUTPUT_CONST = {
  extractTarget: OUTPUT_EXTRACT_TARGET_DEFAULT, // 出力条件（抽出対象）はデフォルト値を設定できるようにしていないため、定数を用意した
  storeOutput: [OUTPUT_COND_STORE.all],
  itemOutput: [OUTPUT_COND_ITEM.tanpin],
  delOutput: [],
}
const DEFAULT_EXTRACT_CONST = {
  validData: [addDayYMD(1), '2999-12-31'],
}
export default defineComponent({
  components: { PageView, SettingImportModal },
  layout: 'sidebar',
  created() {
    this.helper = new importExportHelper(this)
  },
  data() {
    return {
      defaultDateValue: DEFAULT_EXTRACT_CONST.validData,
      resourceType: ResourceType.UiPItemOrderNumAdj,
      templateFile: TemplateFile.UiPItemOrderNumAdj_01,
      extractCondition: {
        validData: DEFAULT_EXTRACT_CONST.validData,
        chubunrui: [],
        shobunrui: [],
        class: [],
        category: [],
        tanpin: [],
      },
      outputCondition: DEFAULT_OUTPUT_CONST,
      outputUseList: [
        {
          outputCondType: 'Store',
          displayItems: DEFAULT_OUTPUT_CONST.storeOutput,
          defaultSelected: DEFAULT_OUTPUT_CONST.storeOutput,
          disabledItems: DEFAULT_OUTPUT_CONST.storeOutput,
        },
        {
          outputCondType: 'Item',
          displayItems: DEFAULT_OUTPUT_CONST.itemOutput,
          defaultSelected: DEFAULT_OUTPUT_CONST.itemOutput,
          disabledItems: DEFAULT_OUTPUT_CONST.itemOutput,
        },
        {
          outputCondType: 'Delete',
          displayItems: [OUTPUT_COND_DELETE.includeDelete],
          defaultSelected: DEFAULT_OUTPUT_CONST.delOutput,
          disabledItems: [],
        },
      ],
      totalCount: null,
      exportSpinner: false,
    }
  },
  methods: {
    changeExtractCondition(cond: ItemOrderNumAdjExtractCondition) {
      console.log('changeExtractCondition', cond)
      this.extractCondition = cond
      this.requestCount()
    },
    changeOutputCondition(cond: ItemOrderNumAdjOutputCondition) {
      console.log('changeConditionCondition', cond)
      this.outputCondition = cond
      this.requestCount()
    },
    async requestCount() {
      this.exportSpinner = true
      this.totalCount = null
      if (this.checkRequired(false)) {
        try {
          const result = await this.$apollo.query({
            query: VUiPItemOrderNumAdjsCountDocument,
            variables: { where: this._createWhere() },
          })
          const data = result.data.vUiPItemOrderNumAdjs.totalCount
          this.totalCount = data.toString()
          this.exportSpinner = false
        } catch (e) {
          console.error(e)
          this.exportSpinner = false
          this.totalCount = '-'
        }
      } else {
        this.exportSpinner = false
        this.totalCount = '-'
      }
    },
    /*********************************
     * 以下はインポートリクエスト用の処理
     *********************************/
    requestImport() {
      console.log('requestImport')
      this.$refs.settingImportModal.show()
    },
    /**
     * インポート開始処理
     */
    async importFileUpload(files: File[]) {
      console.log('importFileUpload', { files })
      this.helper.import({ files: files, resourceType: this.resourceType })
    },
    /*********************************
     * 以下はエクスポートリクエスト用の処理
     *********************************/
    //　入力チェック
    checkRequired(showToast: boolean) {
      // 入力チェック開始
      let errMsg = []
      if (
        !this.extractCondition.validData[0] ||
        !this.extractCondition.validData[1] ||
        (this.extractCondition.chubunrui.length == 0 &&
          this.extractCondition.shobunrui.length == 0 &&
          this.extractCondition.class.length == 0 &&
          this.extractCondition.category.length == 0 &&
          this.extractCondition.tanpin.length == 0)
      ) {
        errMsg.push({
          message: this.$i18n.t('error.requiredItemNotInput'),
        })
      }
      if (this.extractCondition.chubunruiCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.chubunrui'),
            selected: this.extractCondition.chubunruiCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.shobunruiCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.shobunrui'),
            selected: this.extractCondition.shobunruiCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.classCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.class'),
            selected: this.extractCondition.classCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.categoryCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.category'),
            selected: this.extractCondition.categoryCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.tanpinCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.tanpin'),
            selected: this.extractCondition.tanpinCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (errMsg.length) {
        if (showToast) {
          for (const msg of errMsg) {
            Toast.error(this, msg)
          }
        }
        // 入力チェックに引っかかった場合はエクスポートの要求を出さない
        return false
      }
      return true
    },
    /**
     * エクスポート処理
     */
    async requestExport() {
      // this._create_query_string()
      if (this.checkRequired(true)) {
        this.helper.export({
          query: this._create_query_string(),
          jmespathQuery:
            'data.vUiPItemOrderNumAdjs.edges[].node | map(&merge(`{"__update": null}`, @), @)',
          templateFile: this.templateFile,
          filenameExport: EXPORT_FILENAME.item_order_num_adj,
          columnLabelMapping: this._create_column_label_mapping(),
        })
      }
    },
    _create_query_string() {
      const where = this._createWhere()
      const rowQuery = `
query {
  vUiPItemOrderNumAdjs (
    where: ${this.helper.generateQueryWhereString(where)}
    orderBy: ${this._createOrderByString()}
  ) {
    edges {
      node {
        inactiveFlg
        itemCd
        item{
          saleItemName
          uiMCategory1{
            category1Cd
            categoryName
          }
          uiMCategory2{
            category2Cd
            categoryName
          }
          uiMCategory3{
            category3Cd
            categoryName
          }
          uiMRefStoreitemSaleItem{
            vendorCd
          }
          quantity
        }
        saleAmount1w
        discardAmount1w
        discardRate1w
        saleNum1wBefore
        saleNum2wBefore
        saleNum3wBefore
        saleNum3w
        profitRate3w
        price
        cost
        profitRate
        startDate
        endDate
        adjustRate
        totalOrderNumLower
        totalOrderNumUpper
        weeklyMinOrderNum
        weeklyMaxOrderNum
        configuredFlg
        lastModifiedDatetime
        lastModifiedUserName
      }
    }
  }
}
`
      return this.helper.generateQueryString({
        rowQuery: rowQuery,
        resourceType: this.resourceType,
        where: where,
      })
    },
    _createWhere() {
      // 抽出条件
      const ITEM_SEARCH_CONDITION: Where[] = [
        { field: ['startDateNvl'], op: WhereOp.Le, value: [''] },
        { field: ['endDateNvl'], op: WhereOp.Ge, value: [''] },
        {
          field: ['item/category0'],
          op: WhereOp.In,
          value: [''],
        },
        { field: ['item/category1'], op: WhereOp.In, value: [''] },
        { field: ['item/category2'], op: WhereOp.In, value: [''] },
        { field: ['item/category3'], op: WhereOp.In, value: [''] },
        { field: ['itemCd'], op: WhereOp.In, value: [''] },

        // 出力条件
        { field: ['configuredFlg'], op: WhereOp.In, value: [''] },
        { field: ['inactiveFlgNvl'], op: WhereOp.In, value: [''] },
      ]

      const where = JSON.parse(JSON.stringify(ITEM_SEARCH_CONDITION))
      setWhereValue(where, 'startDateNvl', this.extractCondition.validData[1])
      setWhereValue(where, 'endDateNvl', this.extractCondition.validData[0])
      setWhereValue(where, 'item/category0', this.extractCondition.chubunrui)
      setWhereValue(where, 'item/category1', this.extractCondition.shobunrui)
      setWhereValue(where, 'item/category2', this.extractCondition.class)
      setWhereValue(where, 'item/category3', this.extractCondition.category)
      setWhereValue(where, 'itemCd', this.extractCondition.tanpin)
      setWhereValue(where, 'inactiveFlgNvl', [
        '-', // configuredFlgが0のもの
        '0', // 削除されていないデータは必ず出力する
        ...this.outputCondition.delOutput,
      ])

      setWhereValue(where, 'configuredFlg', this.outputCondition.extractTarget)
      console.log({ where })
      return where
    },
    _createOrderByString() {
      const orderBy: OrderBy[] = [
        {
          field: 'item/category1',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'item/category2',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'item/category3',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'price',
          direction: OrderByDirection.Desc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'itemCd',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsFirst,
        },
      ]
      console.log({ orderBy })
      return this.helper.generateQueryOrderByString(orderBy)
    },
    _create_column_label_mapping() {
      const columnLabelMapping: ColumnLabel[] = [
        {
          from: '__update',
          to: '',
        },
        {
          from: 'inactiveFlg',
          to: '',
        },
        {
          from: 'itemCd',
          to: '',
        },
        {
          from: 'item.saleItemName',
          to: '',
        },
        {
          from: 'item.uiMCategory1.category1Cd',
          to: '',
        },
        {
          from: 'item.uiMCategory1.categoryName',
          to: '',
        },
        {
          from: 'item.uiMCategory2.category2Cd',
          to: '',
        },
        {
          from: 'item.uiMCategory2.categoryName',
          to: '',
        },
        {
          from: 'item.uiMCategory3.category3Cd',
          to: '',
        },
        {
          from: 'item.uiMCategory3.categoryName',
          to: '',
        },
        {
          from: 'item.uiMRefStoreitemSaleItem.vendorCd',
          to: '',
        },
        {
          from: 'item.quantity',
          to: '',
        },
        {
          from: 'saleAmount1w',
          to: '',
        },
        {
          from: 'discardAmount1w',
          to: '',
        },
        {
          from: 'discardRate1w',
          to: '',
        },
        {
          from: 'saleNum1wBefore',
          to: '',
        },
        {
          from: 'saleNum2wBefore',
          to: '',
        },
        {
          from: 'saleNum3wBefore',
          to: '',
        },
        {
          from: 'saleNum3w',
          to: '',
        },
        {
          from: 'profitRate3w',
          to: '',
        },
        {
          from: 'price',
          to: '',
        },
        {
          from: 'cost',
          to: '',
        },
        {
          from: 'profitRate',
          to: '',
        },
        {
          from: 'startDate',
          to: '',
        },
        {
          from: 'endDate',
          to: '',
        },
        {
          from: 'adjustRate',
          to: '',
        },
        {
          from: 'totalOrderNumLower',
          to: '',
        },
        {
          from: 'totalOrderNumUpper',
          to: '',
        },
        {
          from: 'weeklyMinOrderNum',
          to: '',
        },
        {
          from: 'weeklyMaxOrderNum',
          to: '',
        },
        {
          from: 'configuredFlg',
          to: '',
        },
        {
          from: 'lastModifiedDatetime',
          to: '',
        },
        {
          from: 'lastModifiedUserName',
          to: '',
        },
      ]
      console.log({ columnLabelMapping })
      return columnLabelMapping
    },
  },
})
